var m = require('mithril');
var IH = require('./IH');
var Contact = require('./Contact');
var Thumbnail = require('./Thumbnail');
var Toggler = require('./Toggler');

var { state } = require('../state');
var breakpoint = require('../utils/breakpoint')

var Logo = {
    view: () => {
        return m('.projects-logo',
            m(IH, { letter: 'i' }),
            m(IH, { letter: 'h' })
        )
    }
}

var minIndex = arr => arr.indexOf(Math.min(...arr));

var columns = (projects) => {

    var cols = breakpoint === 'small'
        ? [
            [m(Logo), m(Contact)]
        ]
        : [
            [],
            [m(Contact)]
        ]

    cols = cols.map(items => ({ items, height: 0 }))

    projects.forEach(project => {

        var shortest = cols[minIndex(cols.map(col => col.height))];

        shortest.items.push(m(Thumbnail, { project }));
        var thumb = project.thumbnail[0];
        shortest.height += thumb.h / thumb.w;

    })

    return cols.map(col => m('.column', col.items));

}

module.exports = {

    onbeforeremove: ({ dom }) => {

        if (!dom) return;

        dom.classList.add('page_exit');

        return new Promise(resolve => setTimeout(resolve, 500));

    },

    view: ({ attrs: { without } }) => {

        var { projects, contact } = state.data;

        projects = projects.filter(project => project.slug !== without);

        return m(Toggler, { visible: state.projectsVisible },
            m('#projects',
                columns(projects, contact)
            )
        );

    }

}


// WEBPACK FOOTER //
// ./js/components/Projects.js